import { flinksLanguages } from '../utils/bankingIntegrationLanguages';

export default {
  // To do APP-2042: Remove usage of "baningConfig.provider" and use new config setup instead
  TS_IFRAME_CAN: 'trustscience-iframe-can',
  TS_IFRAME_US: 'trustscience-iframe-us',
  TS_API_CAN: 'trustscience-api-can',
  FLINKS_IFRAME_CAN: 'flinks-iframe-can',
  FLINKS_IFRAME_US: 'flinks-iframe-us',
  FLINKS_API_CAN: 'flinks-api-can',
  PLAID_LINK: 'plaid-link',
  // End of to do note for APP-2042,
  PLAID: 'plaid',
  FLINKS: 'flinks',
  INVERITE: 'inverite',
  FINICITY: 'finicity',
  AKOYA: 'akoya',
  SMART_SELECT: 'smart',
  STUB: 'stub',
};

export const BANKING_INTEGRATION_TYPES = {
  CLIENT: 'client',
  API: 'api',
};

// eslint-disable-next-line max-len
const FLINKS_CONNECT_PARAMETERS = '?theme=light&desktopLayout=true&innerRedirect=true&headerEnable=false&fixedHeightEnable=false&backgroundColor=FFFFFF&daysOfTransactions=Days365&backEnable=false';

export const generateFlinksIframeURL = (
  connectURL,
  scoringRequestId,
  redirectURL,
  isDemo,
  useUSBanks,
  language,
  webhookData,
  skipConsent,
  bankId,
) => {
  let url = connectURL;
  if (bankId) url += `/Credential/${bankId}`;
  url += FLINKS_CONNECT_PARAMETERS;

  if (webhookData) {
    url += `&tag=${webhookData}`;
  } else {
    url += `&tag=${scoringRequestId}`;
  }

  if (redirectURL) url += `&redirectUrl=${redirectURL}`;

  if (isDemo) url += '&demo=true';

  if (useUSBanks) url += '&institutionsLocation=us';

  if (language) url += `&language=${flinksLanguages(language)}`;

  if (skipConsent) url += '&consentEnable=false';

  return url;
};
